import { render, staticRenderFns } from "./YHSendMeal2Report.vue?vue&type=template&id=70f9ed83&scoped=true&"
import script from "./YHSendMeal2Report.vue?vue&type=script&lang=js&"
export * from "./YHSendMeal2Report.vue?vue&type=script&lang=js&"
import style0 from "./YHSendMeal2Report.vue?vue&type=style&index=0&id=70f9ed83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9ed83",
  null
  
)

export default component.exports